import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
    fn: {__DEPRECATED__dropChildren},
  } = context;
  const {data, tag, children} = jsonNode;
  // 'CommerceAddToCartOptionSelect' type node also has tag as 'select' so the extra check is to make sure this is the form level select
  const isSelect =
    tag === 'select' && data && data.form && data.form.type === 'select';
  const innerHtmlOrChildren =
    jsonNode.hasOwnProperty('v') || (children && children.length > 0);

  return {
    needed: isSelect && innerHtmlOrChildren,
    logData: {
      msg: 'Form select node should not have innerHTML or children',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete jsonNode.v;
      __DEPRECATED__dropChildren(jsonNode);
    },
  };
};
